import type { ConsoleAccount } from '@plato/shared';
import { useState } from 'react';
import type { TenantSummary } from '../data/console-data.ts';
import { applyThemeChoice, readThemeChoice, type ThemeChoice } from './theme.ts';

const ROLE_LABELS = { admin: 'Admin', editor: 'Editor', viewer: 'Viewer' } as const;

export function Header(props: {
  tenants: readonly TenantSummary[];
  current: TenantSummary;
  onSwitch: (tenantId: string) => void;
  account: ConsoleAccount;
  demo: boolean;
  onSignOut: () => void;
  onTryIt?: () => void;
}) {
  const { current } = props;
  return (
    <header className="header">
      <div className="row">
        <label>
          <span className="visually-hidden">Vendor</span>
          <select value={current.id} onChange={(event) => props.onSwitch(event.target.value)}>
            {props.tenants.map((tenant) => (
              <option key={tenant.id} value={tenant.id}>
                {tenant.name}
              </option>
            ))}
          </select>
        </label>
        <span className="chip">
          {current.via === 'staff' ? 'Plato staff' : ROLE_LABELS[current.role]}
        </span>
        {props.demo && <span className="chip chip-warning">Demo data</span>}
      </div>
      <div className="row">
        {props.onTryIt !== undefined && (
          <button type="button" className="primary" onClick={props.onTryIt}>
            Try it
          </button>
        )}
        <ThemeSwitch />
        <span className="muted">{props.account.email ?? props.account.name}</span>
        <button type="button" className="quiet" onClick={props.onSignOut}>
          Sign out
        </button>
      </div>
    </header>
  );
}

function ThemeSwitch() {
  const [choice, setChoice] = useState(readThemeChoice);
  return (
    <label>
      <span className="visually-hidden">Theme</span>
      <select
        value={choice}
        onChange={(event) => {
          const next = event.target.value as ThemeChoice;
          applyThemeChoice(next);
          setChoice(next);
        }}
      >
        <option value="auto">Theme: system</option>
        <option value="light">Theme: day</option>
        <option value="dark">Theme: night</option>
      </select>
    </label>
  );
}
